import React from 'react'
import { ChevronLeft } from 'lucide-react';
import { Employee } from 'src/redux/types/_employee.type';
import EditEmployeeForm from './edit-employee-form';
import { Button } from 'src/components/buttons/shadcn-button';

interface EmployeeDetailsProps {
  defaultView: () => void;
  employee: Employee;
}

const EditEmployee = ({ defaultView, employee }: EmployeeDetailsProps) => {
  return (
    <div className="flex flex-col min-h-screen">
      <div className="p-3 flex items-center justify-between">
        <h1 className="font-medium text-2xl mx-auto">Edit Employee Details</h1>
        <Button
          className=""
          onClick={defaultView}
        >
          <ChevronLeft />
          Back
        </Button>
      </div>

      <div className="flex-1 flex flex-col">
        <EditEmployeeForm employee={employee} back={defaultView}/>
      </div>
    </div>
  );
}

export default EditEmployee
